const routePrefix = '';

const NavigationType = {
  ALL: 'all',
  OUTRIGHTS: 'outrights',
  BET_BUILDER: 'betBuilder',
  RESULTS: 'results',
  POPULAR: 'popular',
  MULTIPLES_OF_THE_DAY: 'multiplesOfTheDay',
  BOOSTED_ODDS: 'boostedOdds',
  TODAY: 'today',
  VIRTUALS: 'virtuals',
};

export const pathMap = {
  [NavigationType.ALL]: (alias, gameType, isSeparate) => (isSeparate ? `/${gameType}/all` : `/${gameType}/all/${alias}`),

  [NavigationType.OUTRIGHTS]: (alias, _, isSeparate) => (isSeparate ? '/prematch/outrights' : `/prematch/outrights/${alias}`),

  [NavigationType.BET_BUILDER]: (alias, _, isSeparate) => (isSeparate ? '/prematch/betBuilder' : `/prematch/betBuilder/${alias}`),

  [NavigationType.RESULTS]: () => '/results',

  [NavigationType.POPULAR]: (alias, gameType, isSeparate) => (isSeparate ? `/${gameType}/popular` : `/${gameType}/popular/${alias}`),

  [NavigationType.MULTIPLES_OF_THE_DAY]: (alias, gameType) => `${routePrefix}/${gameType}/all/multiples`,

  [NavigationType.BOOSTED_ODDS]: (alias, gameType) => `${routePrefix}/${gameType}/all/boosted/all/all`,

  [NavigationType.TODAY]: () => '/prematch?filterType=todaytoday',

  [NavigationType.VIRTUALS]: () => '/prematch/virtuals',
};
